export default __webpack_public_path__ + "static/media/BrainBreak cards105.cd53c886.png";